import { addNotify } from 'features/notify';
import getTokenData from 'shared/helpers/getTokenData';

const actionTypes = {
  ACTION_PROCESSING: 'payment/ACTION_PROCESSING',
  GET_CURRENCY_RATE: 'payment/GET_CURRENCY_RATE',
  DEPOSIT_INIT: 'payment/DEPOSIT_INIT',
  GET_DEPOSIT_INFO: 'payment/GET_DEPOSIT_INFO',
  GET_DEPOSIT_HISTORY: 'payment/GET_DEPOSIT_HISTORY',
  TOP_UP_SUCCESS: 'payment/TOP_UP_SUCCESS',
  ACTION_FAILURE: 'payment/ACTION_FAILURE',
  CLEAR_PAYMENT_LINK: 'payment/CLEAR_PAYMENT_LINK',
};


const getCurrencyRate = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const response = await api.bithidePayment.getCurrencyRate();
  if (response.success) {
    dispatch({ type: actionTypes.GET_CURRENCY_RATE, payload: response.data });
  }
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
}

const depositInit = ({ requestData, callback }) => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const response = await api.bithidePayment.depositInit(requestData);
  if (response.success) {
    dispatch({ type: actionTypes.DEPOSIT_INIT, payload: response.data });
    if (callback) {
      callback();
    }
  } else {
    const { locale } = getState().locale;
    const errorMessage = locale.hasOwnProperty(response.codeStatus)
      ? locale[response.codeStatus]
      : response.errorMessage;
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
}

const getDepositInfo = ({ requestData, callback }) => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const response = await api.bithidePayment.getDepositInfo(requestData);
  if (response.success) {
    dispatch({ type: actionTypes.GET_DEPOSIT_INFO, payload: response.data });
    if (callback) {
      callback();
    }
  } else {
    const { locale } = getState().locale;
    const errorMessage = locale.hasOwnProperty(response.codeStatus)
      ? locale[response.codeStatus]
      : response.errorMessage;
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
}

const getDepositHistory = requestData => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const response = await api.bithidePayment.getDepositHistory(requestData);
  if (response.success) {
    dispatch({ type: actionTypes.GET_DEPOSIT_HISTORY, payload: response.data });
  } else {
    const { locale } = getState().locale;
    const errorMessage = locale.hasOwnProperty(response.codeStatus)
      ? locale[response.codeStatus]
      : response.errorMessage;
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
}

function clearPaymentLink() {
  return async dispatch => {
    dispatch({ type: actionTypes.CLEAR_PAYMENT_LINK });
  };
}

function initPaykassmaDeposit({ amount, returnUrl, paymentSystem }) {
  return async (dispatch, getState, extra) => {
    const tokenData = getTokenData(getState().auth);
    const { api } = extra;


    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

    const { isAuth } = getState().auth;

    if (isAuth) {
      try {
        const response = await api.PaykassmaApi.paykassmaDeposit({
          amount,
          returnUrl,
          paymentSystem,
          sessionToken: tokenData,
        });
        if (response.success) {
          dispatch({ type: actionTypes.TOP_UP_SUCCESS, payload: { ...response.data, amount } });
        } else {
          dispatch({ type: actionTypes.ACTION_FAILURE });
          dispatch(addNotify(response.errorMessage, 'error'));
        }
      } catch (err) {
        dispatch({ type: actionTypes.ACTION_FAILURE });
        dispatch(addNotify(err.message, 'error'));
      }
    } else {
      await dispatch(clearPaymentLink());
    }
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
  };
}

export {
  actionTypes,
  getCurrencyRate,
  depositInit,
  getDepositInfo,
  getDepositHistory,
  initPaykassmaDeposit,
  clearPaymentLink,
};
